import {motion} from 'framer-motion';
import {useMouseMoveUI} from '../../contexts/mouse-move-context';
import {Link, useParams, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import GeneralUtils from "../../utils/GeneralUtils";
import {LoginService} from "../../service/LoginService";
import {EMAIL} from "../../utils/Constants";

const Activation = () => {
    const {mouseDirection, mouseReverse} = useMouseMoveUI();
    const [activated, setActivated] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const service = new LoginService();

    useEffect(() => {
        let activationKey = searchParams.get("activationKey");
        let passwordChangeKey = searchParams.get("passwordChangeKey");
        if (!GeneralUtils.isNullOrEmpty(activationKey)) {
            let data = {
                key: activationKey
            };
           service.activateUser(data).then((response) => {
               if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                   && GeneralUtils.isNullOrEmpty(response.error)) {
                     setActivated(true);
               }
           });

        } else if (!GeneralUtils.isNullOrEmpty(passwordChangeKey)) {

        }

    }, [searchParams]);

    const activatedContent = (
         <div className="content">
            <h2 className="title">Hesabınız Onaylandı.</h2>
            <h4 className="subtitle">Çukurova Üniversitesi Dijital Eğitim Platformu ile öğrenmenin yeni yolunu
                keşfedin.</h4>
            <Link to="/">
                <a className="edu-btn">
                    <i className="icon-west"></i>Anasayfaya Dön
                </a>
            </Link>
        </div>
    )

    const notActivatedContent = (
        <div className="content">
            <h2 className="title">Aktivasyon Kodu Geçersiz!</h2>
            <h4 className="subtitle">Aşağıdaki mail adresi üzerinden sistem yöneticinizle iletişime geçiniz.
                <li><a href={`mailto:${EMAIL}`} rel="noreferrer" target="_blank">{EMAIL}</a></li>
            </h4>

            <Link to="/">
                <a className="edu-btn">
                    <i className="icon-west"></i>Anasayfaya Dön
                </a>
            </Link>
        </div>
    )


    return (
        <>
            <section className="section-gap-equal error-page-area">
                <div className="container">
                    <div className="edu-error">
                        <div className="thumbnail">
                            <img src="/assets/images/others/404.png" alt="404 Error"/>
                            <ul className="shape-group">
                                <motion.li className="shape-1 scene"
                                           animate={{
                                               x: mouseReverse(30).x,
                                               y: mouseReverse(30).y
                                           }}
                                >
                                    <img src="/assets/images/about/shape-25.png" alt="Shape"/>
                                </motion.li>
                                <motion.li className="shape-2 scene"
                                           animate={{
                                               x: mouseDirection(30).x,
                                               y: mouseDirection(30).y
                                           }}
                                >
                                    <img src="/assets/images/about/shape-15.png" alt="Shape"/>
                                </motion.li>
                                <motion.li className="shape-3 scene"
                                           animate={{
                                               x: mouseReverse(30).x,
                                               y: mouseReverse(30).y
                                           }}
                                >
                                    <img src="/assets/images/about/shape-13.png" alt="Shape"/>
                                </motion.li>
                                <motion.li className="shape-4 scene"
                                           animate={{
                                               x: mouseDirection(30).x,
                                               y: mouseDirection(30).y
                                           }}
                                >
                                    <img src="/assets/images/counterup/shape-02.png" alt="Shape"/>
                                </motion.li>
                            </ul>
                        </div>
                        {activated ? activatedContent : notActivatedContent}
                    </div>
                </div>
                <ul className="shape-group">
                    <li className="shape-1">
                        <img src="/assets/images/others/map-shape-2.png" alt="Shape"/>
                    </li>
                </ul>
            </section>
        </>
    )
}

export default Activation;